// extracted by mini-css-extract-plugin
export var circle = "style-module--circle--cjzkB";
export var cta = "style-module--cta--p17Rs";
export var divider = "style-module--divider--dOaaD";
export var dotsWrapper = "style-module--dotsWrapper--Ao+f4";
export var gadgetPosition = "style-module--gadgetPosition--4fqpn";
export var gadgetPosition2 = "style-module--gadgetPosition2--dI15Y";
export var header = "style-module--header--F0qrI";
export var imageWrapper = "style-module--imageWrapper--AHQGt";
export var linkedin = "style-module--linkedin--VTOAV";
export var list = "style-module--list--4P6D7";
export var listItem = "style-module--listItem--iPZHx";
export var mentorImg = "style-module--mentorImg--GBtyQ";
export var mentors = "style-module--mentors--DT-La";
export var name = "style-module--name--K+Qx6";
export var nameAndTitle = "style-module--nameAndTitle--cGX4J";
export var root = "style-module--root--zW6JG";
export var title = "style-module--title--ZD8l6";
export var workshop = "style-module--workshop--oE8fM";
export var workshopTitle = "style-module--workshopTitle--sQl61";